
































import Vue from 'vue';
import TopNav from '@/web/components/navigation/TopNav.vue';
import { mapGetters } from 'vuex';
import { errorToMessage } from '@/core/utils/errors';
import GiftsPurchasesTable from '@/web/components/gift/GiftsPurchasesTable.vue';

export default Vue.extend({
  name: 'GiftPurchases',
  components: {
    TopNav,
    GiftsPurchasesTable,
  },
  computed: {
    ...mapGetters({
      giftsPurchasesStats: 'sale/giftsPurchasesStats',
    }),
  },
  async mounted() {
    try {
      await this.$store.dispatch('sale/getGiftsPurchasesStats');
    } catch (error) {
      this.$notify({
        group: 'app',
        type: 'error',
        title: 'Failed to load gifts purchases statistics',
        text: errorToMessage(error?.response, `Request failed: ${error}`),
        duration: -1, // stay ON
      });
    }
  },
});
